import { useEffect, useMemo, useState } from 'react';
import { useWalletModal } from '../context/WalletModalContext';
import ALL_WALLET_NAMES from '../data/allWallets';
import ProfileModal from './ProfileModal';
import '../styles/WalletModal.css';
// import { WalletMetamask, WalletWalletConnect, WalletLedger } from '@web3icons/react';
import {
  WalletMetamask,
  WalletLedger,
  WalletWalletConnect,
  WalletZerion,
  WalletOkx,
  WalletCoinbase,
  WalletPhantom,
  WalletMyEtherWallet,
  WalletRabby,
  WalletRainbow,
  WalletTrust,
  WalletArgent,
  WalletSafe,
  WalletVenly,
  WalletPillar,
  WalletImtoken,
  WalletTokenPocket,
  WalletAtomic,
  WalletCoin98,
  WalletAlphaWallet,
  WalletKeplr,
  WalletRonin,
  WalletExodus,
} from '@web3icons/react';

const WALLET_ICON_MAP = {
  'MetaMask': WalletMetamask,
  'Ledger Wallet': WalletLedger,
  'Ledger Live': WalletLedger,
  'Zerion Wallet': WalletZerion,
  'OKX Wallet': WalletOkx,
  'Coinbase Wallet': WalletCoinbase,
  'Phantom': WalletPhantom,
  'MEW Wallet': WalletMyEtherWallet,
  'Rabby Wallet': WalletRabby,
  'Rainbow': WalletRainbow,
  'Trust Wallet': WalletTrust,
  'Argent': WalletArgent,
  'Gnosis Safe': WalletSafe,
  'Venly Wallet': WalletVenly,
  'Pillar': WalletPillar,
  'imToken': WalletImtoken,
  'TokenPocket': WalletTokenPocket,
  'Atomic Wallet': WalletAtomic,
  'Coin98': WalletCoin98,
  'AlphaWallet': WalletAlphaWallet,
  'Keplr Wallet': WalletKeplr,
  'Ronin Wallet': WalletRonin,
  'Exodus': WalletExodus,
};

const ICON_VARIANT_OVERRIDES = {
  'MetaMask': 'branded',
  'Coinbase Wallet': 'branded',
};

function getIconVariant(name) {
  return ICON_VARIANT_OVERRIDES[name] || 'mono';
}



const IMAGE_ICON_MAP = {
  'Uniswap Wallet': '/wallet-logos/uniswap.svg',
  'Polkadot Wallet': '/wallet-logos/polkadot.png',
  'HashPack Wallet': '/wallet-logos/hashpack.svg',
  'BankSocial Wallet': '/wallet-logos/banksocial.png',
  'Binance Wallet': '/wallet-logos/binance.png',
  'SafePal Wallet': '/wallet-logos/safepal.svg',
  'Fetch.ai Wallet': '/wallet-logos/fetchai.jpg',
  'Bifrost Wallet': '/wallet-logos/bifrost.jpg',
  'Shido Wallet': '/wallet-logos/shido.png',
  'XUMM Wallet': '/wallet-logos/xumm.jpg',
  'GateWeb3 Wallet': '/wallet-logos/gateweb3.png',
  'BitGet Wallet': '/wallet-logos/bitget.png',
  'Robinhood Wallet': '/wallet-logos/robinhood.jpg',
  'Frontier Wallet': '/wallet-logos/frontier.jpg',
  'Grove Wallet': '/wallet-logos/grove.webp',
  'SafeMoon Wallet': '/wallet-logos/safemoon.jpg',
  'SaitaPro Wallet': '/wallet-logos/saitapro.jpg',
  'Enjin Wallet': '/wallet-logos/enjin.webp',
  'Blockchain.com Wallet': '/wallet-logos/blockchain.png',
  'BRISE Wallet': '/wallet-logos/brise.jpg',
  "D'CENT Wallet": '/wallet-logos/dcent.png',
  'Equal Wallet': '/wallet-logos/equal.jpg',
  'MEET.ONE': '/wallet-logos/meetone.jpg',
  'MoriX Wallet': '/wallet-logos/morix.png',
  'Brave Wallet': '/wallet-logos/bravelogo.avif',
  'Crypto.com Wallet': '/wallet-logos/crypto-com.png',
  'ONTO': '/wallet-logos/onto.png',
  'MathWallet': '/wallet-logos/mathwallet.jpg',
  'BitPay': '/wallet-logos/bitpay.jpg',
  'Walleth': '/wallet-logos/walleth.png',
  'Authereum': '/wallet-logos/authereum.png',
  'Dharma': '/wallet-logos/dharma.png',
  '1inch Wallet': '/wallet-logos/1inch.png',
  'Huobi Wallet': '/wallet-logos/huobi.png',
  'Eidoo': '/wallet-logos/eidoo.png',
  'MYKEY': '/wallet-logos/mykey.png',
  'Loopring Wallet': '/wallet-logos/loopring.png',
  'TrustVault': '/wallet-logos/trustvault.jpg',
  'CoolWallet': '/wallet-logos/coolwallet.png',
  'Alice': '/wallet-logos/alice.png',
  'ZelCore': '/wallet-logos/zelcore.png',
  'Nash': '/wallet-logos/nash.jpg',
  'Nova Wallet': '/wallet-logos/nova.jpg',
  'FOX Wallet': '/wallet-logos/fox.jpg',
  'Coinomi': '/wallet-logos/coinomi.png',
  'GridPlus': '/wallet-logos/gridplus.png',
  'CYBAVO Wallet': '/wallet-logos/cybavo.jpg',
  'Torus': '/wallet-logos/torus.jpg',
  'Spatium': '/wallet-logos/spatium.png',
  'Infinito': '/wallet-logos/infinito.webp',
  'wallet.io': '/wallet-logos/wallet-io.jpg',
  'Infinity Wallet': '/wallet-logos/infinity.png',
  'BitVerse Wallet': '/wallet-logos/bitverse.png',
  'Solace Wallet': '/wallet-logos/solace.jpg',
  'Ownbit': '/wallet-logos/ownbit.png',
  'EasyPocket': '/wallet-logos/easypocket.jpg',
  'Bridge Wallet': '/wallet-logos/bridge.png',
  'SparkPoint': '/wallet-logos/sparkpoint.png',
  'ViaWallet': '/wallet-logos/viawallet.jpg',
  'BitKeep': '/wallet-logos/bitkeep.png',
  'Vision': '/wallet-logos/vision.jpg',
  'PEAKDEFI Wallet': '/wallet-logos/peakdefi.jpg',
  'Unstoppable Wallet': '/wallet-logos/unstoppable.jpg',
  'HaloDeFi Wallet': '/wallet-logos/halodefi.png',
  'Dok Wallet': '/wallet-logos/dok.png',
  'AT.Wallet': '/wallet-logos/atwallet.png',
  'Midas Wallet': '/wallet-logos/midas.png',
  'Ellipal': '/wallet-logos/ellipal.png',
  'KEYRING Pro': '/wallet-logos/keyring.svg',
  'Aktionariat': '/wallet-logos/aktionariat.png',
  'Talken Wallet': '/wallet-logos/talken.jpg',
  'XinFin XDC Wallet': '/wallet-logos/xinfin.png',
  'Flare Wallet': '/wallet-logos/flare.jpg',
  'KyberSwap': '/wallet-logos/kybersnap.png',
  'AToken Wallet': '/wallet-logos/atoken.png',
  'RWallet': '/wallet-logos/rwallet.png',
  'PlasmaPay': '/wallet-logos/plasmapay.jpg',
  'O3Wallet': '/wallet-logos/o3wallet.jpg',
  'HashKey Wallet': '/wallet-logos/hashkey.png',
  'Jade Wallet': '/wallet-logos/jade.png',
  'Guarda Wallet': '/wallet-logos/guarda.jpg',
  'Defiant': '/wallet-logos/defiant.jpg',
  'Trustee Wallet': '/wallet-logos/trustee.png',
  'Tokenary': '/wallet-logos/tokenary.png',
  'Tongue Wallet': '/wallet-logos/tongue.jpg',
  'ByBit Wallet': '/wallet-logos/bybit.png',
};

// Placeholder wallet options — this is a UI mockup only, no real
// web3/wallet SDK is wired in. Each option has its own onClick so
// you can drop in real connection logic (wagmi, ethers, etc.) later
// without touching the modal shell.
const WALLET_OPTIONS = [
  { id: 'bifrost', label: 'Bifrost Wallet', bg: '#5b4fe0' },
  { id: 'metamask', label: 'MetaMask', bg: '#ffffff' },
  { id: 'walletconnect', label: 'WalletConnect', bg: '#3b82f6' },
  { id: 'ledger', label: 'Ledger Wallet', bg: '#000000' },
  { id: 'all', label: 'All Wallets', bg: '#dbeafe' },
];

const AVATAR_COLORS = [
  '#5b4fe0', '#e8831d', '#3b82f6', '#10b981', '#ef4444',
  '#f59e0b', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16',
];

function colorFor(name) {
  let sum = 0;
  for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
}

export default function WalletModal() {
  const { isOpen, closeWallet } = useWalletModal();
  const [view, setView] = useState('list'); // 'list' | 'all' | 'connecting'
  const [search, setSearch] = useState('');
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [connectStage, setConnectStage] = useState('loading'); // 'loading' | 'error'
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // reset everything whenever the modal closes
  useEffect(() => {
    if (!isOpen) {
      const t = setTimeout(() => {
        setView('list');
        setSearch('');
        setSelectedWallet(null);
        setConnectStage('loading');
        setIsProfileOpen(false);
      }, 200);
      return () => clearTimeout(t);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    function handleKey(e) {
      if (e.key === 'Escape') closeWallet();
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, closeWallet]);

  // fake connection attempt: show "Connecting..." for ~1.8s, then
  // switch to the error state with a manual-entry fallback. This is
  // a UI mockup only — no real wallet connection is attempted.
  useEffect(() => {
    if (view !== 'connecting') return;
    setConnectStage('loading');
    const t = setTimeout(() => setConnectStage('error'), 1800);
    return () => clearTimeout(t);
  }, [view, selectedWallet]);

  const filteredWallets = useMemo(() => {
    const q = search.trim().toLowerCase();
    const list = q
      ? ALL_WALLET_NAMES.filter((n) => n.toLowerCase().includes(q))
      : ALL_WALLET_NAMES;
    return list;
  }, [search]);

  function beginConnection(label) {
    setSelectedWallet(label);
    setView('connecting');
  }

  function handleSelect(id) {
    if (id === 'all') {
      setView('all');
      return;
    }
    const wallet = WALLET_OPTIONS.find((w) => w.id === id);
    beginConnection(wallet ? wallet.label : id);
  }

  function handleGridSelect(name) {
    beginConnection(name);
  }

  function handleEnterManually() {
    setIsProfileOpen(true);
  }

  function handleProfileClose() {
    setIsProfileOpen(false);
    setView('list');
    setSelectedWallet(null);
    setConnectStage('loading');
  }

  return (
    <>
      <div
        className={`wm-overlay${isOpen && !isProfileOpen ? ' open' : ''}`}
        onClick={closeWallet}
        aria-hidden={!isOpen || isProfileOpen}
        style={isProfileOpen ? { display: 'none' } : undefined}
      >
        <div
          className={`wm-card${view === 'all' ? ' wm-card-wide' : ''}`}
          role="dialog"
          aria-modal="true"
          aria-label={
            view === 'all'
              ? 'Select your wallet'
              : view === 'connecting'
              ? 'Automatic Connection'
              : 'Connect wallet'
          }
          onClick={(e) => e.stopPropagation()}
        >
          <div className="wm-header">
            <h2 className="wm-title">
              {view === 'all'
                ? 'Select your wallet'
                : view === 'connecting'
                ? 'Automatic Connection'
                : 'Connect Wallet'}
            </h2>
            <button
              type="button"
              className="wm-close"
              onClick={closeWallet}
              aria-label="Close"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 6l12 12M18 6L6 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>

          {view === 'list' && (
            <div className="wm-list">
              {WALLET_OPTIONS.map((wallet) => (
                <button
                  key={wallet.id}
                  type="button"
                  className="wm-option"
                  onClick={() => handleSelect(wallet.id)}
                >
                  <span
                    className="wm-icon"
                    style={{ background: wallet.bg }}
                    aria-hidden="true"
                  >
                    <WalletGlyph id={wallet.id} />
                  </span>
                  <span className="wm-option-label">{wallet.label}</span>
                </button>
              ))}
            </div>
          )}

          {view === 'all' && (
            <>
              <div className="wm-search">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="11" cy="11" r="7" stroke="#8a8c92" strokeWidth="2" />
                  <path d="M21 21l-4.3-4.3" stroke="#8a8c92" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search wallet"
                  autoFocus
                />
              </div>

              <div className="wm-grid">
              {filteredWallets.map((name) => {
                const Icon = WALLET_ICON_MAP[name];
                return (
                  <button
                    key={name}
                    type="button"
                    className="wm-grid-item"
                    onClick={() => handleGridSelect(name)}
                  >
                    {Icon ? (
                        <span className="wm-grid-avatar wm-grid-avatar-icon">
                          <Icon
                            size={24}
                            variant={getIconVariant(name)}
                            color="#ffffff"
                            aria-hidden="true"
                          />
                        </span>
                       ) : IMAGE_ICON_MAP[name] ? (
                        <span className="wm-grid-avatar wm-grid-avatar-icon">
                          <img
                            src={IMAGE_ICON_MAP[name]}
                            alt=""
                            width={24}
                            height={24}
                            style={{ objectFit: 'contain' }}
                          />
                        </span>
                       ) : (
                        <span
                          className="wm-grid-avatar"
                          style={{ background: colorFor(name) }}
                        >
                          {name.charAt(0).toUpperCase()}
                        </span>
                    )}
                    <span className="wm-grid-label">{name}</span>
                  </button>
                );
              })}

                <button
                  type="button"
                  className="wm-grid-item"
                  onClick={() => handleGridSelect('Others')}
                >
                  <span className="wm-grid-avatar wm-grid-avatar-plus">+</span>
                  <span className="wm-grid-label">Others</span>
                </button>

                {filteredWallets.length === 0 && (
                  <p className="wm-no-results">No wallets match "{search}"</p>
                )}
              </div>
            </>
          )}

          {view === 'connecting' && (
            <div className="wm-connect">
              {connectStage === 'loading' && (
                <div className="wm-connect-status">
                  <span>Connecting...</span>
                  <span className="wm-spinner" aria-hidden="true" />
                </div>
              )}

              {connectStage === 'error' && (
                <div className="wm-connect-error">
                  Oops! something went wrong while processsing connection...
                  Please try again later or connect manually.
                </div>
              )}

              <div className="wm-connect-info">
                <p className="wm-connect-info-title">{selectedWallet}</p>
                <p className="wm-connect-info-desc">
                  This session is protected with end-to-end encryption.
                </p>
              </div>

              {connectStage === 'error' && (
                <button
                  type="button"
                  className="wm-manual-btn"
                  onClick={handleEnterManually}
                >
                  Enter Manually
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      <ProfileModal
        isOpen={isProfileOpen}
        onClose={handleProfileClose}
      />
    </>
  );
}

// Simple original glyphs — not reproductions of any wallet's real logo artwork.
function WalletGlyph({ id }) {
  const size = 20;

  if (id === 'bifrost') {
    return (
      <img
        src="/wallet-logos/bifrost.jpg"
        alt=""
        width={size}
        height={size}
        style={{ objectFit: 'contain', borderRadius: '4px' }}
      />
    );
  }
  if (id === 'metamask') {
    return <WalletMetamask size={size} variant="branded" aria-hidden="true" />;
  }
  if (id === 'walletconnect') {
    return <WalletWalletConnect size={size} variant="branded" aria-hidden="true" />;
  }
  if (id === 'ledger') {
    // Ledger's "branded" variant is solid black — invisible on your dark
    // background. Same fix as the big wallet grid: use "mono" instead.
    return (
      <WalletLedger size={size} variant="mono" color="#ffffff" aria-hidden="true" />
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="6" height="6" rx="1.5" fill="#3b82f6" />
      <rect x="11" y="3" width="6" height="6" rx="1.5" fill="#93c5fd" />
      <rect x="3" y="11" width="6" height="6" rx="1.5" fill="#93c5fd" />
      <path d="M14 11v6M11 14h6" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}